export function loadRecaptchaConfig () {
  return window.axios.get('/ui-config').then(uiConfig => {
    return {
      recaptchaKey: uiConfig.data.recaptchaKey || '',
      recaptchaEnterprise: uiConfig.data.recaptchaEnterprise !== false
    }
  }).catch(() => {
    return {
      recaptchaKey: '',
      recaptchaEnterprise: true
    }
  })
}
